import { useCallback, useEffect, useState } from "react";
import { getControlEffectivenessConfig } from "../api/controlEffectivenessConfig.api";
import { DEFAULT_CONTROL_EFFECTIVENESS_CONFIG } from "../utils/controlEffectiveness";

const CHANGE_EVENT = "controlEffectivenessConfigChanged";

export function useControlEffectivenessConfig({ enabled = true } = {}) {
  const [items, setItems] = useState(DEFAULT_CONTROL_EFFECTIVENESS_CONFIG);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState(null);

  const load = useCallback(async ({ force = false } = {}) => {
    if (!enabled) return;
    setLoading(true);
    setError(null);
    try {
      const response = await getControlEffectivenessConfig({ force });
      setItems(response?.data?.items || DEFAULT_CONTROL_EFFECTIVENESS_CONFIG);
    } catch (err) {
      setItems(DEFAULT_CONTROL_EFFECTIVENESS_CONFIG);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return undefined;
    }

    load();
    const handleChange = () => {
      load({ force: true });
    };
    window.addEventListener(CHANGE_EVENT, handleChange);
    return () => {
      window.removeEventListener(CHANGE_EVENT, handleChange);
    };
  }, [enabled, load]);

  return {
    items,
    loading,
    error,
    refresh: () => load({ force: true }),
  };
}

export const CONTROL_EFFECTIVENESS_CONFIG_EVENT = CHANGE_EVENT;
